import { useEffect, useRef } from "react";
import { useBondRetrievalGuardianDropdowns } from "../../Bond Retrieval/hooks/useBondRetrievalGuardianDropdowns";
import { getHistoricAttorneyLawFirmId } from "../historicGuardianConfig";

/**
 * Historic guardian forms: shared cities/states + PG + attorneys loading (matches Bond Retrieval hook behavior).
 * @param {object} opts
 * @param {object} opts.historicCfg - entry from HISTORIC_GUARDIAN_CONFIG
 * @param {string} opts.role - Redux auth role
 * @param {{ lawfirmId?: number }} opts.lawfirm
 * @param {() => void} [opts.scrollToTop]
 */
export function useHistoricGuardianDropdowns({
  historicCfg,
  role,
  lawfirm,
  scrollToTop,
}) {
  const attorneyLawFirmId = getHistoricAttorneyLawFirmId(role, lawfirm);
  const didScrollAfterCities = useRef(false);

  const dropdowns = useBondRetrievalGuardianDropdowns({
    attorneyLawFirmId,
    mapProfessionalGuardian: historicCfg.mapProfessionalGuardian,
    isGuest: historicCfg.isGuest,
    attorneyFetchMode: "bulk",
  });

  useEffect(() => {
    scrollToTop?.();
  }, [scrollToTop]);

  useEffect(() => {
    if (
      scrollToTop &&
      !dropdowns.loadingCitiesStates &&
      dropdowns.allCities?.length > 0 &&
      !didScrollAfterCities.current
    ) {
      didScrollAfterCities.current = true;
      scrollToTop();
    }
  }, [
    dropdowns.loadingCitiesStates,
    dropdowns.allCities,
    scrollToTop,
  ]);

  return dropdowns;
}
